module.exports = __webpack_public_path__ + "static/service16-e09a68c809fbce23d1e155e4f5815f67.jpg";